import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { NavBar } from './components/NavBar';
import { AddTool } from './pages/AddTool';
import { Dashboard } from './pages/Dashboard';
import { DigestHistory } from './pages/DigestHistory';
import { RegistryBrowser } from './pages/RegistryBrowser';
import { ToolDetail } from './pages/ToolDetail';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-background font-sans">
        <NavBar />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/registry" element={<RegistryBrowser />} />
          <Route path="/registry/:slug" element={<ToolDetail />} />
          <Route path="/add-tool" element={<AddTool />} />
          <Route path="/digest" element={<DigestHistory />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
